<template>
  <cac-page>
    <banner-section
      :page-key="componentUniqueKey"
      :wrapper-form-button-text="$t('cac.app.check_registration_status')"
    >
      <template slot="left-wrapper">
        <cac-page-header
          slot="pre-content"
          :title="actionTitle"
        />
        <div class="voter-information__options d-flex flex-column">
          <div
            v-for="(option, index) in voterInfoOptions"
            :key="index"
            :class="{'mb-2': isLastIndex(index)}">
            <icon
              :icon-name="checkIcon"
              view-box="0 0 12 12"
              class="mr-2"/>
            <span class="">{{ option }}</span>
          </div>
        </div>
      </template>
    </banner-section>
  </cac-page>
</template>

<script>
import { mapState } from "vuex";
import STATE from "Constants/campaign/civicactioncenter/state";
import Icon from "StyleguideComponents/Icon.vue";
import CacPage from "CivicActionCenterComponents/layout/CACPage.vue";
import CacPageHeader from "CivicActionCenterComponents/layout/CACPageHeader.vue";
import BannerSection from "CivicActionCenterComponents/shared/BannerSection.vue";
import RouteNames from "Constants/campaign/civicactioncenter/routeNames";
import { CHECK } from "Constants/styleguide/iconNames";
import SharedMixin from "JS/mixins/campaign/civicactioncenter/shared";
import { isEmpty as _isEmpty } from "lodash";

export default {
  name: "VoterInformationBanner",
  components: {
    CacPage,
    CacPageHeader,
    Icon,
    BannerSection
  },
  mixins: [SharedMixin],
  data() {
    return {
      RouteNames,
      checkIcon: CHECK
    };
  },
  computed: {
    ...mapState(STATE.SCOPE_CAMPAIGN, ["cacVoterInformation"]),
    voterInfoOptions() {
      return [
        this.$t("cac.app.voter_registration_status"),
        this.$t("cac.app.polling_place"),
        this.$t("cac.app.absentee_ballots"),
        this.$t("cac.app.election_rules"),
        this.$t("cac.app.official_state_website")
      ];
    },
    actionTitle() {
      return !_isEmpty(this.cacVoterInformation.cta)
        ? this.cacVoterInformation.cta
        : this.$t("cac.app.your_voter_information");
    }
  },
  methods: {
    isLastIndex(index) {
      return index < this.voterInfoOptions.length - 1;
    }
  }
};
</script>
